<template>
    <section id="Alert" v-if="hasAlert">
        <!-- <div class="alert alert-warning alert-dismissible">
            <button type="button" class="close" data-dismiss="alert"><span>×</span></button>
            <span class="font-weight-semibold"><i class="fas fa-exclamation-triangle"></i> Warning!</span> Please verify your email <a href="#" class="alert-link"><u>patrick_pppat@info.com</u></a> Click here to confirm your email.
        </div> -->
    </section>
</template>
<script>
export default {
    data() {
        return {
            hasAlert: true
        }
    },
}
</script>



// WEBPACK FOOTER //
// src/components/central/account/Alert.vue